import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Button, Stack, Typography} from 'views/components';
import {OpenInNew} from 'views/icons';
import {Translate} from 'views/module';

import backend from 'utils/backend';

const JobResponseView = (props) => {
  const {response, statusProgressWrap} = props;

  const [jobData, setJobData] = React.useState(response);
  const clientRn = response?.client?.clientRn;
  const clientName = jobData?.client?.clientName;

  React.useEffect(() => {
    let isMounted = true;

    setJobData(response);

    if (!clientRn || clientRn === 'null') {
      return () => {
        isMounted = false;
      };
    }

    statusProgressWrap(async () => {
      const clientResponse = await backend.client.getClient(clientRn);
      const loadedClientName = clientResponse?.clientDetail?.clientName;

      if (!isMounted || !loadedClientName) {
        return;
      }

      setJobData({
        ...response,
        client: {
          ...response.client,
          clientName: loadedClientName,
        },
      });
    }, {
      onErrorMessage: 'Failed to load client data',
      showProgress: false,
    });

    return () => {
      isMounted = false;
    };
  }, [clientRn, response, statusProgressWrap]);

  const createJobUrl = React.useMemo(() => {
    return `/career/create?jobData=${encodeURIComponent(JSON.stringify(jobData))}`;
  }, [jobData]);

  const handleCreateJob = React.useCallback(() => {
    window.open(createJobUrl, '_blank', 'noopener,noreferrer');
  }, [createJobUrl]);

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #CDD7FF',
        borderRadius: '16px',
        boxShadow: '0px 1px 2px rgba(130, 145, 255, 0.06)',
      }}
    >
      <Stack
        direction='row'
        alignItems='center'
        sx={{
          p: '12px 18px',
          justifyContent: 'space-between',
          gap: '12px',
        }}
      >
        <Stack
          direction='row'
          alignItems='center'
          sx={{
            gap: '8px',
          }}
        >
          <OpenInNew
            sx={{
              fontSize: '18px',
              color: '#6F6A62',
            }}
          />
          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#6F6A62',
            }}
          >
            <Translate
              expression='skills.SkillsModule.Job.OpenInAnotherTab'
              substitute={{clientName}}
            />
          </Typography>
        </Stack>
        <Button
          disableElevation
          onClick={handleCreateJob}
          sx={{
            'px': '10px',
            'py': '8px',
            'borderRadius': '7px',
            'fontSize': '11px',
            'fontWeight': 400,
            'lineHeight': '100%',
            'textTransform': 'none',
            'color': '#FFFFFF',
            'backgroundColor': '#E4875B',
            '&:hover': {
              backgroundColor: '#DB7D51',
            },
          }}
        >
          <Translate expression='career.create.Actions.CreateJob' />
        </Button>
      </Stack>
    </Box>
  );
};

JobResponseView.propTypes = {
  response: PropTypes.object,
  statusProgressWrap: PropTypes.func.isRequired,
};

export default connect(null, dispatch)(React.memo(JobResponseView));
